/**
 * Component: Navigation
 */


var dnDepartments = dnDepartments || {};

dnDepartments.navigation = dnDepartments.navigation || function () {

	this.init = function() {
		toggleMobileNavigation();
		navigationDepartment();
	};

	this.toggleMobileNavigation = function(){
		if ($('#js-mobile-navigation').length > 0) {
			$('#js-mobile-navigation-trigger, #js-mobile-navigation__close-button').on('click', function(){
				if (!$('#js-mobile-navigation').hasClass('js-active')) {
					$('#js-mobile-navigation').addClass('js-active');
					dnDepartments.overlay.backdrop();
					$('body').addClass('mobile-nav-open');
				}
				else {
					$('#js-mobile-navigation').removeClass('js-active');
					dnDepartments.overlay.destroy();
					$('body').removeClass('mobile-nav-open');
				}
			});
		}
	};

	this.navigationDepartment = function(){
		if( $('#js-navigation-department').length) {
			var 	subToggle = $('.js-sub-toggle');

			subToggle.on('click', function(e){
				$(this).siblings('ul').toggleClass('open');
			});
		}
	};

	/**
	 * Function to move navigation elements based on window width
	 */
	this.moveNavigationElements = function() {
		if ($('#js-mobile-navigation').length > 0) {

			var siteHeader = $('#js-site-header'),
				siteHeaderInner = $('.site-header__inner', siteHeader),
				topLinks = $('#js-top-links'),
				navigationDepartment = $('#js-navigation-department'),
				siteCta = $('#js-site-cta'),
				mobileNavigation = $('#js-mobile-navigation'),
				mobileNavigationInner = $('#js-mobile-navigation__inner'),
				mobileCloseButton = $('#js-mobile-navigation__close-button'),
				mobileCtaContainer = $('#js-mobile-navigation__cta');

			setTimeout(function() {
				if (window.innerWidth < 992) {
					/*
					 * Move elements to mobile view
					 */
					// Site CTA
					siteCta.appendTo(mobileCtaContainer);

					// Top links
					topLinks.insertBefore(mobileCtaContainer);

					// Navigation branch
					navigationDepartment.insertBefore(mobileCtaContainer);

				}
				else {
					/*
					 * Move elements to mobile view
					 */
					// Top links
					topLinks.insertBefore(siteHeaderInner);

					// Site CTA
					siteCta.insertBefore($('.site-search', siteHeaderInner));

					// Navigation Branch
					navigationDepartment.insertAfter(mobileNavigation);
				}
			}, 300);
		}
	};

	return {
		init : init,
		moveNavigationElements : moveNavigationElements,
		navigationDepartment : navigationDepartment
	};
}();
